import store from '../../store'
import Vue from 'vue'
import {CONFIG_WS_URL, PREFIX_WS} from '../../utils/config'

export default () => {
  const arr = ['Vettori', 'Hotels', 'Servizi', 'Tours', 'Experiences']
  let promises = []
  arr.forEach((ctx, index) => {
    promises[index] = Vue.axios.get(`${CONFIG_WS_URL}${PREFIX_WS}-${ctx.toLowerCase()}`).then(response => {
      store.dispatch(`loadAll${ctx}`, response.data)
      return true
    })
  })
  return Promise.all(promises)
}



// WEBPACK FOOTER //
// ./src/front/actions/config/load-all.js